// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a6387b27","455":"2b8e04f2","946":"9a804b69"}[chunkId] + ".chunk.js";
};